// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.component {
  display: flex;
  background-color: var(--app-main-darker);
}
.component .side {
  /*&:not(:last-of-type) {
    border-right: 1px solid var(--app-main-softer);
  }*/
}
.component .side.side-left {
  flex: 1;
  padding: 6px 15px;
  padding-right: 10px;
  display: flex;
}
.component .side.side-left .btns-wrap {
  display: flex;
  align-items: center;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn {
  margin: 0;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn .td-btn-inner {
  padding: 8px;
  display: flex;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn .td-btn-inner .btn-icon {
  font-size: 30px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 {
  flex: 1;
  padding: 0 15px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn {
  margin: 0;
  --border-radius: 6px;
  border-radius: 6px;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner {
  padding: 8px 12px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner .unread-circle {
  position: absolute;
  top: 12px;
  left: calc(50% + 3px);
  border-radius: 10px;
  padding: 1px 3px;
  height: 14px;
  font-size: 11px;
  background-color: var(--app-danger);
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner .btn-icon {
  font-size: 28px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner .btn-lbl {
  padding-top: 9px;
  font-size: 12px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn:not(:last-child) {
  margin-right: 7px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn.selected {
  background-color: var(--app-main-strong);
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn.selected .td-btn-inner {
  cursor: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-3 {
  padding-left: 10px;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn {
  margin: 0;
  --border-radius: 6px;
  border-radius: 6px;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner {
  padding: 8px 12px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner .unread-circle {
  position: absolute;
  top: 6px;
  left: calc(50% + 7px);
  border-radius: 10px;
  padding: 1px 3px;
  height: 14px;
  font-size: 11px;
  background-color: var(--app-danger);
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner .btn-icon {
  font-size: 28px;
  position: relative;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner .btn-lbl {
  padding-top: 9px;
  font-size: 12px;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn:not(:last-child) {
  margin-right: 7px;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn.selected {
  background-color: var(--app-main-strong);
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn.selected .td-btn-inner {
  cursor: auto;
}
.component .side.side-left .manage-fleet {
  color: white;
  font-size: 12px;
  display: flex;
  border-radius: 5px;
  background-color: var(--app-main-strong);
  height: 40px;
  margin: auto;
  cursor: pointer;
}
.component .side.side-left .manage-fleet .inner-fleet {
  padding: 10px 14px 10px 14px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
  font-weight: 600;
}
.component .side.side-left .manage-fleet .inner-fleet .btn-icon {
  font-size: 18px;
}
.component .side.side-left .manage-fleet .inner-fleet .selected-fleet {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.component .side.side-left .manage-fleet .inner-fleet .selected-fleet .small {
  font-size: 9px;
  font-weight: 400;
}
.component .side.side-left .manage-fleet .inner-fleet .selected-fleet .main {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  text-transform: uppercase;
  min-width: 50px;
  max-width: 100px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.component .side.side-left .manage-fleet .inner-fleet .selected-fleet .main span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.component .side.side-right .recipient-topbar-inner {
  padding: 8px 0;
  padding-right: 20px;
  min-height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  /*.recipient-body {
    flex: 1;
    padding: 0 15px;

    display: flex;
    align-items: center;

    // infos (lines)
    .rb-infos {
      width: 100%;
      display: flex;


      .info-col {
        display: flex;

        .info-row {
          display: flex;
          align-items: center;


          .info-part {

            &.ip-name {
              display: grid;

              .name-text {
                @extend %oneLiner;

                color: #fff;
                font-size: 15px;
                font-weight: 500;

                // to balance emojis height
                line-height: 18px; !* normal text's height, no emojis *!
              }
            }//&.ip-name


            &.ip-last-seen {
              display: grid;

              .last-seen-text {
                @extend %oneLiner;

                color: #fff;

                font-size: 14px;
                // to balance emojis height
                line-height: 16px; !* normal text's height, no emojis *!
              }
            }//&.ip-last-seen

          }//.info-part


          !*&:not(:last-child) {
            margin-bottom: 4px;
          }*!

          &.info-row-1 {
            margin-bottom: 2px;
          }
        }//.info-row


        &.info-col-main {
          padding-right: 15px;
          flex: 1;

          flex-direction: column;
          justify-content: center;
        }

        &.info-col-actions {
          align-items: center;

          .action-btn {
            margin: 0;
            --border-radius: 50%;

            --padding-top: 5px;
            --padding-bottom: 5px;
            --padding-start: 5px;
            --padding-end: 5px;

            height: auto;

            font-size: 12px;

            .action-btn-icon {
              margin-bottom: -2px;
              margin-top: 2px;
            }

            !*&:last-child {
              margin-right: -5px;
            }*!
          }//.action-btn

        }//&.info-col-actions


      }//.info-col


    }//.rb-infos
  }*/
}
.component .side.side-right .recipient-topbar-inner .main-logo {
  max-height: 45px;
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.component .side.side-right .recipient-topbar-inner .recipient-head {
  /* .rec-avatar {
    //box-sizing: content-box;
    //border: 2px solid var(--app-succ);

    border-radius: 50%;
    overflow: hidden;


    height: 50px;
    width: 50px;
    background-color: var(--app-main);

    display: flex;


    // picture
    .avatar-pic {
      width: 100%;

      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    // initials
    .avatar-lbl {
      align-self: center;
      width: 100%;

      margin: 0 8px;


      color: #fff;
      font-size: 17px;
      font-weight: 600;

      text-align: center;
      //text-transform: uppercase;


      @extend %oneLiner;


      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;


      &.sm {
        margin: 0 5px;
        font-size: 14px;
      }
    }//.avatar-lbl

  } */
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/components/desktop/topbar/topbar.component.scss"],"names":[],"mappings":"AA+RA;EACE,kBAAA;AC9RF;ADgSE;EACE,gBAAA;AC9RJ;ADkSE;EAwBE;;IAAA;ACrTJ;AD+RI;EACE,uBAAA;AC7RN;ADiSI;EACE,yBAAA;AC/RN;ADkSI;EACE,0BAAA;AChSN;ADoSI;EACE,sBAAA;AClSN;ADqSI;EACE,6BAAA;ACnSN;AD0SI;EACE,6BAAA;ACxSN;AD2SI;EACE,6BAAA;ACzSN;AD6SI;EACE,2BAAA;AC3SN;AD8SI;EACE,6BAAA;AC5SN;AD+SI;EACE,+BAAA;AC7SN;;AA/BA;EACE,aAAA;EACA,wCAAA;AAkCF;AAhCE;EAmdE;;IAAA;AA9aJ;AAnCI;EACE,OAAA;EAEA,iBAAA;EACA,mBAAA;EAGA,aAAA;AAkCN;AA/BM;EACE,aAAA;EACA,mBAAA;AAiCR;AA5BU;EACE,SAAA;EACA,oBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;AA4BZ;AA1BY;EACE,YAAA;EACA,aAAA;AA4Bd;AA1Bc;EACE,eAAA;AA4BhB;AApBQ;EACE,OAAA;EAGA,eAAA;AAoBV;AAlBU;EACE,SAAA;EAEA,oBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;AAiBZ;AAdY;EACE,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AAed;AAbc;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;EAGA,mBAAA;EACA,gBAAA;EAGA,YADO;EAGP,eAAA;EAEA,mCAAA;AAShB;AANc;EACE,eAAA;AAQhB;AALc;EACE,gBAAA;EAEA,eAAA;AAMhB;AAEY;EACE,iBAAA;AAAd;AAGY;EACE,wCAAA;AADd;AAGc;EACE,YAAA;AADhB;AASQ;EAEE,kBAAA;AARV;AAUU;EACE,SAAA;EAEA,oBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;AAXZ;AAcY;EACE,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,kBAAA;AAdd;AAgBc;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EAGA,mBAAA;EACA,gBAAA;EAGA,YADO;EAGP,eAAA;EAEA,mCAAA;AApBhB;AAuBc;EACE,eAAA;EACA,kBAAA;AArBhB;AAyBc;EACE,gBAAA;EAEA,eAAA;AAxBhB;AAiCY;EACE,iBAAA;AA/Bd;AAkCY;EACE,wCAAA;AAhCd;AAkCc;EACE,YAAA;AAhChB;AA0CM;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EAEA,wCAAA;EAEA,YAAA;EACA,YAAA;EACA,eAAA;AA1CR;AA4CQ;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA1CV;AA4CU;EACE,eAAA;AA1CZ;AA6CU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3CZ;AA4CY;EACE,cAAA;EACA,gBAAA;AA1Cd;AA4CY;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA3Cd;AA6Cc;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3ChB;AA2DM;EACE,cAAA;EAEA,mBAAA;EAEA,gBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,eAAA;EAsFA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA;AAvCR;AA5CQ;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA8CV;AAlCQ;EAOE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAqFV","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n\n@import \"../../../../theme/desktop/desktop\";\n\n\n\n\n\n.component {\n  display: flex;\n  background-color: var(--app-main-darker);\n\n  .side {\n\n    &.side-left {\n      flex: 1;\n\n      padding: 6px 15px;\n      padding-right: 10px;\n\n      //background-color: var(--app-main);\n      display: flex;\n\n\n      .btns-wrap {\n        display: flex;\n        align-items: center;\n\n\n        &.btns-wrap-1 {\n\n          .tb-btn {\n            margin: 0;\n            --border-radius: 50%;\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n            .td-btn-inner {\n              padding: 8px;\n              display: flex;\n\n              .btn-icon {\n                font-size: 30px;\n              }\n            }//.td-btn-inner\n          }//.tb-btn\n\n        }//&.btns-wrap-1\n\n\n        &.btns-wrap-2 {\n          flex: 1;\n\n          //padding: 0 20px;\n          padding: 0 15px;\n\n          .tb-btn {\n            margin: 0;\n\n            --border-radius: 6px;\n            border-radius: 6px; // useful when selected\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n\n            .td-btn-inner {\n              padding: 8px 12px 7px;\n\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n\n              .unread-circle {\n                position: absolute;\n                top: 12px;\n                left: calc(50% + 3px);\n\n                //border-radius: 50%;\n                border-radius: 10px;\n                padding: 1px 3px;\n\n                $size: 14px;\n                height: $size;\n                //width: $size;\n                font-size: 11px;\n\n                background-color: var(--app-danger);\n              }\n\n              .btn-icon {\n                font-size: 28px;\n              }\n\n              .btn-lbl {\n                padding-top: 9px;\n\n                font-size: 12px;\n                //font-weight: 600;\n\n                //text-transform: none;\n              }\n            }//.td-btn-inner\n\n\n            &:not(:last-child) {\n              margin-right: 7px;\n            }\n\n            &.selected {\n              background-color: var(--app-main-strong);\n\n              .td-btn-inner {\n                cursor: auto;\n              }\n            }//&.selected\n          }//.tb-btn\n\n        }//&.btns-wrap-2\n\n\n        &.btns-wrap-3 {\n          //border-left: 2px solid var(--app-mid-light);\n          padding-left: 10px;\n\n          .tb-btn {\n            margin: 0;\n\n            --border-radius: 6px;\n            border-radius: 6px; // useful when selected\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n\n            .td-btn-inner {\n              padding: 8px 12px 7px;\n\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n\n              position: relative;\n\n              .unread-circle {\n                position: absolute;\n                top: 6px;\n                left: calc(50% + 7px);\n\n                //border-radius: 50%;\n                border-radius: 10px;\n                padding: 1px 3px;\n\n                $size: 14px;\n                height: $size;\n                //width: $size;\n                font-size: 11px;\n\n                background-color: var(--app-danger);\n              }\n\n              .btn-icon {\n                font-size: 28px;\n                position: relative;\n\n              }\n\n              .btn-lbl {\n                padding-top: 9px;\n\n                font-size: 12px;\n                //font-weight: 600;\n\n                //text-transform: none;\n              }\n\n            }\n\n\n            &:not(:last-child) {\n              margin-right: 7px;\n            }\n\n            &.selected {\n              background-color: var(--app-main-strong);\n\n              .td-btn-inner {\n                cursor: auto;\n              }\n            }//&.selected\n          }//.tb-btn\n\n        }//&.btns-wrap-3\n\n\n      }//.btns-wrap\n\n      .manage-fleet{\n        color:  white;\n        font-size: 12px;\n        display: flex;\n        border-radius: 5px;\n        //border: 1px solid white;\n        background-color: var(--app-main-strong);\n\n        height: 40px;\n        margin:auto;\n        cursor: pointer;\n\n        .inner-fleet{\n          padding: 10px 14px 10px 14px;\n          display: flex;\n          flex-direction: row;\n          justify-content: flex-end;\n          gap: 10px;\n          align-items: center;\n          font-weight: 600;\n\n          .btn-icon{\n            font-size: 18px;\n          }\n\n          .selected-fleet{\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n            .small{\n              font-size: 9px;\n              font-weight: 400;\n            }\n            .main{\n              font-size: 12px;\n              font-weight: 600;\n              display: flex;\n              text-transform: uppercase;\n              min-width: 50px;\n              max-width: 100px;\n\n              display: block;\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n\n              span{\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n              }\n            }\n\n          }\n        }\n\n      }\n\n    }//&.side-left\n\n\n    &.side-right {\n      //max-width: 400px;\n      //background-color: var(--app-main-strong);\n\n      .recipient-topbar-inner {\n        padding: 8px 0;\n\n        padding-right: 20px;\n\n        min-height: 100%;\n\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n\n        // Aggiunta Vigo\n        .main-logo{\n          max-height: 45px;\n          width: auto;\n          padding-left: 15px;\n          padding-right: 15px;\n        }\n        //.main-logo{\n        //  max-height: 60px;\n        //  width: auto;\n        //  padding-left: 0px;\n        //  padding-right: 0px;\n        //}\n        // Fine aggiunta Vigo\n\n\n        // REMOVE?\n        .recipient-head {\n          //padding-left: 20px;\n\n          //display: flex;\n          //align-items: center;\n\n          // recipient's avatar\n          /* .rec-avatar {\n            //box-sizing: content-box;\n            //border: 2px solid var(--app-succ);\n\n            border-radius: 50%;\n            overflow: hidden;\n\n\n            height: 50px;\n            width: 50px;\n            background-color: var(--app-main);\n\n            display: flex;\n\n\n            // picture\n            .avatar-pic {\n              width: 100%;\n\n              background-repeat: no-repeat;\n              background-position: center;\n              background-size: cover;\n            }\n\n            // initials\n            .avatar-lbl {\n              align-self: center;\n              width: 100%;\n\n              margin: 0 8px;\n\n\n              color: #fff;\n              font-size: 17px;\n              font-weight: 600;\n\n              text-align: center;\n              //text-transform: uppercase;\n\n\n              @extend %oneLiner;\n\n\n              -webkit-user-select: none;\n              -moz-user-select: none;\n              -ms-user-select: none;\n              user-select: none;\n\n\n              &.sm {\n                margin: 0 5px;\n                font-size: 14px;\n              }\n            }//.avatar-lbl\n\n          } *///.rec-avatar\n        }//.recipient-head\n\n\n        // REMOVE?\n        /*.recipient-body {\n          flex: 1;\n          padding: 0 15px;\n\n          display: flex;\n          align-items: center;\n\n          // infos (lines)\n          .rb-infos {\n            width: 100%;\n            display: flex;\n\n\n            .info-col {\n              display: flex;\n\n              .info-row {\n                display: flex;\n                align-items: center;\n\n\n                .info-part {\n\n                  &.ip-name {\n                    display: grid;\n\n                    .name-text {\n                      @extend %oneLiner;\n\n                      color: #fff;\n                      font-size: 15px;\n                      font-weight: 500;\n\n                      // to balance emojis height\n                      line-height: 18px; !* normal text's height, no emojis *!\n                    }\n                  }//&.ip-name\n\n\n                  &.ip-last-seen {\n                    display: grid;\n\n                    .last-seen-text {\n                      @extend %oneLiner;\n\n                      color: #fff;\n\n                      font-size: 14px;\n                      // to balance emojis height\n                      line-height: 16px; !* normal text's height, no emojis *!\n                    }\n                  }//&.ip-last-seen\n\n                }//.info-part\n\n\n                !*&:not(:last-child) {\n                  margin-bottom: 4px;\n                }*!\n\n                &.info-row-1 {\n                  margin-bottom: 2px;\n                }\n              }//.info-row\n\n\n              &.info-col-main {\n                padding-right: 15px;\n                flex: 1;\n\n                flex-direction: column;\n                justify-content: center;\n              }\n\n              &.info-col-actions {\n                align-items: center;\n\n                .action-btn {\n                  margin: 0;\n                  --border-radius: 50%;\n\n                  --padding-top: 5px;\n                  --padding-bottom: 5px;\n                  --padding-start: 5px;\n                  --padding-end: 5px;\n\n                  height: auto;\n\n                  font-size: 12px;\n\n                  .action-btn-icon {\n                    margin-bottom: -2px;\n                    margin-top: 2px;\n                  }\n\n                  !*&:last-child {\n                    margin-right: -5px;\n                  }*!\n                }//.action-btn\n\n              }//&.info-col-actions\n\n\n            }//.info-col\n\n\n          }//.rb-infos\n        }*///.recipient-body\n\n\n      }//.recipient-topbar-inner\n    }//&.side-right\n\n\n    /*&:not(:last-of-type) {\n      border-right: 1px solid var(--app-main-softer);\n    }*/\n  }//.side\n\n\n}//.component\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
